import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function getActiveAssets(employee_id: number, company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpAssetsList?emp_id=${employee_id}&company_id=${company_id}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getReturnAssets(employee_id: number, company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpReturnedAssetsList?emp_id=${employee_id}&company_id=${company_id}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function returnAssetRequest(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/returnAsset`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAvailableEmpAssetList(company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/listAvailableAssetsEmpPortal?company_id=${company_id}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function assignAssets(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.post(`/v1/assignAsset`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
export const assetsService = {
  getActiveAssets,
  getReturnAssets,
  returnAssetRequest,
  getAvailableEmpAssetList,
  assignAssets,
};
